import React, { useState, useEffect } from 'react';
import './notifications.css';
import { useAuth } from '../services/AuthContext.js';
import { Bell, BellOff, ExternalLink, Loader2 } from 'lucide-react';

const baseAPI_URL = process.env.REACT_APP_BACKEND_API_BASE_ENDPOINT;

export function Notifications() {
  const { user, getIdToken } = useAuth();
  const [notificationsOpen, setNotificationsOpen] = useState(false);
  const [nofificationsLoading, setNotificationsLoading] = useState(false);
  const [allNotifications, setAllNofifications] = useState([]);
  const toggleNotifications = () => setNotificationsOpen(prev => !prev);

  const formatDate = (utcString) => {
    const date = new Date(utcString);
    return new Intl.DateTimeFormat(undefined, {
      dateStyle: 'medium',
      timeStyle: 'short',
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }).format(date);
  };

  const loadNotifications = async () => {
    try {
      setNotificationsLoading(true);
      const token = await getIdToken();
      const response = await fetch(`${baseAPI_URL}/notifications`, {
        headers: {
          Authorization: `Bearer: ${token}`
        }
      });
      const data = await response.json();
      setAllNofifications(data);
    } catch (err) {
      console.error("Error loading notifications: ", err);
    } finally {
      setNotificationsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      loadNotifications();
    }
  }, [user]);

  if (!user) {
    return null;
  }

  const notificationCount = Array.isArray(allNotifications) ? allNotifications.length : 0;
  const badgeLabel = notificationCount > 99 ? '99+' : String(notificationCount);

  return (
    <div className={`dropdown-container notifications-container ${notificationsOpen ? 'open' : ''}`}>
      <button
        type="button"
        className="menu-button-desktop internal-link dropdown-toggle-btn notifications-bell-btn"
        onClick={toggleNotifications}
        aria-expanded={notificationsOpen}
        aria-haspopup="true"
        aria-label={notificationCount > 0 ? `${notificationCount} notificações` : 'Notificações'}
      >
        <span className="notifications-bell-icon">
          <Bell size={22} className="notifications-bell-svg" />
          {notificationCount > 0 && (
            <span className="notifications-badge">{badgeLabel}</span>
          )}
        </span>
      </button>

      <div className={`notifications-menu ${notificationsOpen ? 'visible' : ''}`} role="menu">
        <div className="notifications-menu-header">
          <h3 className="notifications-menu-title">Notificações</h3>
          {notificationCount > 0 && (
            <span className="notifications-count-chip">{badgeLabel}</span>
          )}
        </div>

        <div className="notifications-menu-body">
          {nofificationsLoading ? (
            <div className="notifications-state">
              <Loader2 size={28} className="notifications-state-spinner" />
              <p className="notifications-state-text">Carregando notificações...</p>
            </div>
          ) : notificationCount > 0 ? (
            allNotifications.map((item, index) => (
              <div key={index} className="notification-item" role="none">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="notification-link"
                  role="menuitem"
                >
                  <span className="notification-date">{formatDate(item.created_at)}</span>
                  <span className="notification-text">{item.content}</span>
                  <span className="notification-action">
                    Acessar <ExternalLink size={14} />
                  </span>
                </a>
              </div>
            ))
          ) : (
            <div className="notifications-state">
              <BellOff size={32} className="notifications-state-icon" />
              <p className="notifications-state-text">Nenhuma notificação por enquanto</p>
              <p className="notifications-state-subtext">Quando houver novidades, elas aparecem aqui.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
